import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { DebitoAutomaticoContrato } from '../modelo/debito-automatico-contrato';
import { DebitoAutomaticoContratoDetalhe } from '../modelo/debito-automatico-contrato-detalhe';
import { Config } from '../services/config';
import { DebitoAutomaticoService } from '../services/debitoautomatico.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { SegundaViaService } from '../services/segundavia.service';
import { SessaoService } from '../services/sessao.service';
import { AbstractComponent } from '../util/abstract.component';

declare var $: any;

@Component({
  selector: 'app-debito-automatico-contrato-modal',
  templateUrl: './debito-automatico-contrato-modal.component.html',
  styleUrls: ['./debito-automatico-contrato-modal.component.css'],
  providers: [SegundaViaService, DebitoAutomaticoService, MensagemService, RestClientService]
})
export class DebitoAutomaticoContratoModalComponent extends AbstractComponent implements OnInit {

  optinLimite: string = "";
  optinVencida: string = "";
  debitoAutomaticoContratoDetalhe: DebitoAutomaticoContratoDetalhe = new DebitoAutomaticoContratoDetalhe();

  constructor(
    private sessaoService: SessaoService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private debitoAutomaticoService: DebitoAutomaticoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DebitoAutomaticoContratoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
    this.optinLimite = data.optinLimite;
    this.optinVencida = data.optinVencida;
    this.debitoAutomaticoContratoDetalhe = data.debitoAutomaticoContratoDetalhe;
  }

  ngOnInit() {
    setTimeout(function () {
      $('.cdk-global-overlay-wrapper').css({ 'align-items': "flex-end" });
    }, 0);
  }

  confirmar () {
    let debitoAutomaticoContrato = new DebitoAutomaticoContrato();
    debitoAutomaticoContrato.nuContrato = this.debitoAutomaticoContratoDetalhe.nuContrato;
    debitoAutomaticoContrato.optinLimite = this.optinLimite;
    debitoAutomaticoContrato.optinVencida = this.optinVencida
    this.debitoAutomaticoService.efetivarAlteracaoDebitoAutomatico(debitoAutomaticoContrato).subscribe(
      (result: any) => {
        if (result.cdMsgemRetorno == "0") {
          sessionStorage.setItem("debitoAutomaticoContrato",JSON.stringify(result));
          this.router.navigate(['/BF-Portal/debitoautomaticoconclusao']);
          this.fechar();
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Fecha a modal
   */
  fechar() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/debito-automatico/debito-automatico-contrato-modal.component.ts